module.exports = __webpack_public_path__ + "b2ec24502b78b0c023e613a8cfd7b208.pdf";